import { checkScriptIsLoaded, ResolutionStrategy, loadScript } from '../script-loader.esm.js';

var baseUrl = 'https://maps.googleapis.com/maps/api/js?libraries=places,geometry';
/**
 * Build google-maps api url to load.
 * Available parameter can be found here: https://developers.google.com/maps/documentation/javascript/load-maps-js-api#use-legacy-tag
 *
 * @param conf url configuration
 * @returns string
 */
var googleApiUrl = function (conf) {
    var _a;
    var accessToken = conf.accessToken, mapId = conf.mapId, version = conf.version, locale = conf.locale;
    var language;
    var region;
    if (locale) {
        // eslint-disable-next-line no-useless-escape
        _a = /^([a-z]{2})((\-|\_)([A-Z]{2}))?$/.exec(locale) || [], language = _a[1], region = _a[4];
    }
    var params = {
        callback: 'googleMapsLoadedCallback',
        key: accessToken,
        map_ids: mapId,
        channel: null,
        language: "".concat(language === null || language === void 0 ? void 0 : language.toLowerCase()).concat(region ? "-".concat(region.toUpperCase()) : ''),
        region: region === null || region === void 0 ? void 0 : region.toUpperCase()
    };
    if (version !== '') {
        params.v = version || 'quarterly';
    }
    var paramStr = Object.keys(params)
        .filter(function (k) { return params[k] !== undefined; })
        .map(function (k) { return "".concat(k, "=").concat(params[k]); })
        .join('&');
    return "".concat(baseUrl).concat(baseUrl.indexOf('?') > 0 ? '&' : '?').concat(paramStr);
};
var removeGoogleMapScript = function () {
    // Remove google from BOM (window object)
    window.google = undefined;
    // Remove google map scripts from DOM
    Array.prototype.slice
        .call(document.getElementsByTagName('script'))
        .filter(function (script) { return typeof script.src === 'string' && script.src.includes('maps.googleapis'); })
        .forEach(function (script) { return script.remove(); });
};
var checkApiIsLoaded = function () { return window.google !== undefined && window.google.maps !== undefined; };
var checkApiIsLoading = function () { return window.googleMapsLoading === true; };
/**
 * Load google-maps api.
 *
 * @param reloadSDK force to reload sdk if already loaded. Useful when you want to change the locale that has been loaded.
 * @param conf the api configuration to used
 * @param resolveImmediately don't wait for google-maps callback to revolve this call.
 * @returns returns true if the api was loaded through this call, and false if the api was already loaded and not force to be reloaded.
 */
var initGoogleMapsApi = function (reloadSDK, conf, resolveImmediately) {
    return new Promise(function (resolve, reject) {
        var scriptId = 'loading-google-maps';
        if (checkApiIsLoaded() && !reloadSDK) {
            resolve(false);
        }
        else if (checkApiIsLoading()) {
            checkScriptIsLoaded('google.maps', checkApiIsLoaded, checkApiIsLoading, { delay: 200, maxRetries: 100 })
                .then(function () { return resolve(false); })
                .catch(function (err) { return reject(err); });
        }
        else {
            removeGoogleMapScript();
            window.googleMapsLoading = true;
            window.googleMapsLoadedCallback = function () {
                window.googleMapsLoading = undefined;
                if (!resolveImmediately)
                    resolve(true);
            };
            var url = googleApiUrl(conf);
            var dontAskScriptLoaderToWait = ResolutionStrategy.IMMEDIATELY;
            loadScript(url, true, scriptId, dontAskScriptLoaderToWait)
                .then(function () {
                if (resolveImmediately) {
                    resolve(true);
                }
            })
                .catch(function (err) { return reject(err); });
        }
    });
};

export { initGoogleMapsApi };
